<template>
  <div class="login-dailog dialog">
    <div class="title">
      <h1>使用者登入</h1>
    </div>
    <div class="content container">
      <table class="modal-form">
        <tr class="input">
          <td class="ti">
            <label for="account">
              <i class="fa fa-user fa-fw" aria-hidden="true"></i>
            </label>
          </td>
          <td>
            <input type="text" id="account" name="account" v-model="login.username" v-validate="'required'" @keyup.enter="validateUserLogin()">
          </td>
        </tr>
        <tr class="text">
          <td class="ti">
            <p></p>
          </td>
          <td>
            <p class="error" v-show="errors.has('account')">{{ errors.first('account') }}</p>
          </td>
        </tr>
        <hr class="no-border">
        <tr class="input">
          <td class="ti">
            <label for="password">
              <i class="fa fa-unlock-alt fa-fw" aria-hidden="true"></i>
            </label>
          </td>
          <td>
            <input type="password" id="password" name="password" v-model="login.password" v-validate="'required'" @keyup.enter="validateUserLogin()">
          </td>
        </tr>
        <tr class="text">
          <td class="ti">
            <p></p>
          </td>
          <td>
            <p class="error" v-show="errors.has('password')">{{ errors.first('password') }}</p>
          </td>
        </tr>
        <tr class="text">
          <td class="ti">
            <p></p>
          </td>
          <td>
            <p>請用 <strong>後台</strong> 帳號 登入</p>
          </td>
        </tr>
      </table>
    </div>
    <div class="buttons container">
      <button class="main-button field-button" :class="{ loading: onSubmit }" :disabled="onError" @click="validateUserLogin()">
        <i class="fa fa-sign-in" aria-hidden="true"></i>
        <span>登入</span>
      </button>
    </div>
  </div>
</template>

<script>
import { postUser } from '../../api'
import loginData from '../../mixins/loginData'
import toastMethods from '../../mixins/toastMethods'

export default {
  mixins: [
    loginData,
    toastMethods
  ],
  props: {
    param: {
      type: Object,
      default: () => ({ route: { name: 'main' } })
    }
  },
  data () {
    return {
      login: {
        username: '',
        password: ''
      },
      onSubmit: false
    }
  },
  computed: {
    onError () {
      let value = true
      if (this.errors.items.length === 0) {
        value = false
      }
      if (this.onSubmit) {
        value = true
      }
      return value
    }
  },
  methods: {
    async validateUserLogin () {
      this.onSubmit = true
      let result = await this.$validator.validateAll()
      if (result) {
        await this.userLogin()
      } else {
        this.onSubmit = false
      }
    },
    async userLogin () {
      try {
        let data = this.login
        let response = await postUser(data)
        this.setUserData(response)
        this.clickRouter(this.param.route)
        this.addToast('success', '登入成功')
        this.onSubmit = false
      } catch (error) {
        this.setLoginAction(false)
        this.addToast('error', !error.response ? error.message : error.response.data.errors[0])
        this.onSubmit = false
      }
    },
    clickRouter (route) {
      this.$emit('changeModal')
      this.$router.push(route)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/login.vue